<script>
    import geos from "../stores/geos";
    import kritikes from "../stores/kritikes";
    import {createEventDispatcher} from 'svelte';
    import {JSONClone, findNode, backPath} from "../lib/lib";
    import {setFocusTo} from "../lib/lib";
    import app_alert from "../stores/alerts";
    import success from '../stores/success';

    const dispatch = createEventDispatcher();

    export let geo;

    let parentsPath = '';
    let geoTitle = '';

    const onClick = () => {
        $geos.selected_id = geo.id;
    }

    const onToggle = () => {
        if (geo.children.length > 0) {
            geo.expanded = !geo.expanded;
        }
        onClick();
    }

    const onNameClick = (event) => {
        if (event.ctrlKey && geo.children.length > 0) {
            onToggle();
        }
    }

    const onNameDoubleClick = () => {
        dispatch('edit', geo);
    }

    const onOpenMap = () => {
        let zoom = 12;
        if (geo.level == 0) {
            zoom = 10;
        }
        window.open(`https://www.google.com/maps/@${geo.latlng},${zoom}z`, '_blank').focus();
    }

    const onFindMatch = location_id => {
        $kritikes.search_term = location_id;
    }

    const setMatches = () => {
        geo.geo_matches = null;
        // find multiple matches for this location
        if ($kritikes.tree) {
            let matches = $kritikes.matches.filter(x => x.geo_id === geo.id);
            if (matches.length) {
                geo.geo_matches = [];
                matches.map(item => {
                    geo.geo_matches = [...geo.geo_matches, {
                        id: item.match_id,
                        name: backPath(item.match_id, $kritikes.tree)
                    }];
                });
            }
        }
    }


    $:{
        if ($geos.marked_id === geo.id) {
            parentsPath = backPath(geo.parent_id, $geos.tree);
        } else {
            parentsPath = '';
        }

        if (geo.match_source !== $geos.match_source) {
            geo.match_source = $geos.match_source;
            setMatches();
        } else if (!geo.geo_matches && $geos.match_source > 0) {
            setMatches();
        }

        geoTitle = "id: " + geo.id + " - level: " + geo.level;

        if (geo.slug == null) {
            geo.slug = '';
        }
    }
</script>

<div class="node-group level-{ geo.level }" id="geo-item-{ geo.id }"
     on:click|preventDefault|stopPropagation="{ onClick }">
    <div class="node" class:selected={ geo.id === $geos.selected_id }>
        {#if geo.children.length > 0}
            <div class="toggle" on:click|preventDefault|stopPropagation="{ onToggle }">
                {#if geo.expanded}
                    <i class="fa fa-chevron-down"></i>
                {:else}
                    <i class="fa fa-chevron-right"></i>
                {/if}
            </div>
        {/if}
        <div class="name" class:marked="{ $geos.marked_id === geo.id }" on:click="{ onNameClick }"
             on:dblclick|preventDefault|stopPropagation="{ onNameDoubleClick }">
                <span class:not-nactive="{ geo.deprecated == 1 }" title="{ geoTitle }">
                    { geo.name_el }
                </span>
            {#if parentsPath}
                <div class="marked-path">
                    { parentsPath }
                </div>
            {/if}
            {#if ($geos.selected_id === geo.id || $geos.marked_id === geo.id) && geo.geo_matches && geo.geo_matches.length}
                <div class="matches">
                    {#each geo.geo_matches as match}
                        <div class="match" title="id: {match.id }">
                            { match.name }
                            <div class="find" on:click={ () => onFindMatch(match.id) }>»</div>
                        </div>
                    {/each}
                </div>
            {/if}
        </div>
        {#if geo.latlng && geo.latlng.length}
            <div class="button" title="Εμφάνιση σε google maps" on:click="{ onOpenMap }"><i
                    class="fa fa-map-marker"></i></div>
        {/if}
        <div class="slug">
            {geo.slug}
        </div>
    </div>

    {#if geo.expanded}
        <div class="children">
            {#each geo.children as child}
                <svelte:self geo="{ child }"
                             on:cancel_edit
                             on:edit
                />
            {/each}
        </div>
    {/if}
</div>

<style>
    .slug {
        float: right;
        color: #878787;
        padding: 5px;
    }
</style>